import React, { Component } from 'react'

class LinkedInputGroup extends Component {
  validate (children, resolve) {
    React.Children.map(children, child => {
      if (!child) return
      if (child.props && child.props.children) {
        this.validate(child.props.children, resolve)
      }
      if (child.type && child.props.path) {
        if (!child.type.prototype.validate.call(child)) {
          document.querySelector('.' + child.props.path.replace(/\./g, '-')).classList.add('form-error')
          resolve(false)
        } else if (document.querySelector('.' + child.props.path.replace(/\./g, '-'))) {
          document.querySelector('.' + child.props.path.replace(/\./g, '-')).classList.remove('form-error')
        }
      }
    })
  }
  check (resolve) {
    this.validate(this.props.children, resolve)
    setTimeout(() => {
      resolve(true)
    }, 0)
  }
  render () {
    return <div>{this.props.children}</div>
  }
}

export default LinkedInputGroup



// WEBPACK FOOTER //
// ./src/components/basic/misc/LinkedInputGroup.js